module.exports = __webpack_public_path__ + "media/images/padlock-20318466491ea589802b80efb5d2df49.svg";